import { createApp } from 'vue'
import __t from "../../../../../helpers/translate";
import vue_helpers from "../../../../../helpers/check_null";
import {createBootstrap} from 'bootstrap-vue-next';
import tender_table from "./tender_table.vue";

window.TENDER_LIST = createApp({
    name : "TENDER_LIST",
    id : "TENDER_LIST",
    components : {
        tender_table : tender_table,
    }
})
    .mixin(__t)
    .mixin(vue_helpers)
    .use(createBootstrap())
    .use(v_store);

TENDER_LIST.mount('#tender_items');